export default __webpack_public_path__ + "static/media/register9.6f089588.jpg";